/**
 * Language selector component.
 * @module components/LanguageSelector/LanguageSelector
 *
 * - Changed dropdown for react-accessible-dropdown-menu-hook
 */

import React from 'react';
import useDropdownMenu from 'react-accessible-dropdown-menu-hook';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { defineMessages, useIntl } from 'react-intl';
import { Icon } from 'iovisit-theme/components';
import cx from 'classnames';
import config from '@plone/volto/registry';
import { find } from 'lodash';
import { Helmet, langmap, flattenToAppURL } from '@plone/volto/helpers';

const messages = defineMessages({
  switchLanguageTo: {
    id: 'Switch to',
    defaultMessage: 'Switch to',
  },
  languageSelector: {
    id: 'Select language',
    defaultMessage: 'Select language',
  },
  changeLanguage: {
    id: 'Change language',
    defaultMessage: 'Change language',
  },
});

const LanguageSelector = ({ onClickAction = () => {} }) => {
  const intl = useIntl();
  const currentLang = useSelector((state) => state.intl.locale);
  const translations = useSelector(
    (state) => state.content.data?.['@components']?.translations?.items,
  );
  const { settings } = config;

  const { buttonProps, itemProps, isOpen } = useDropdownMenu(
    settings.supportedLanguages.length,
  );

  return settings.isMultilingual ? (
    <div className="language-selector-wrapper">
      <div className="iv--language-selector">
        <div className="ui dropdown">
          <div
            {...buttonProps}
            aria-label={intl.formatMessage(messages.changeLanguage)}
          >
            <span className="text">{currentLang.toUpperCase()}</span>
            <Icon prefix="fas" icon="caret-down" className="icon" />
          </div>

          <div className={cx('menu', { visible: isOpen })} role="menu">
            {settings.supportedLanguages.map((lang, i) => {
              const translation = find(translations, { language: lang });

              return (
                <Link
                  {...itemProps[i]}
                  aria-label={`${intl.formatMessage(messages.switchLanguageTo)}
                  ${langmap[lang].nativeName}`}
                  className={cx('item', { selected: lang === currentLang })}
                  to={
                    translation
                      ? flattenToAppURL(translation['@id'])
                      : `/${lang}`
                  }
                  key={`language-selector-${lang}`}
                  onClick={() => {
                    onClickAction();
                  }}
                >
                  {langmap[lang].nativeName}
                </Link>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  ) : (
    <Helmet>
      <html lang={settings.defaultLanguage} />
    </Helmet>
  );
};

export default LanguageSelector;
